export default {
  async fetchNotifications({ commit }) {
    try {
      const { notifications } = await this.$axios.$get(
        `${this.$config.baseUrl}/tmpData/${this.$i18n.locale}/notifications.json`,
      );
      commit('setNotifications', { data: notifications });
    } catch {}
  },
};
